import api from './api';
import { AppResponse } from "../models/common/app-response";
import { LinkObjectDto } from '../models/common/linkObjectDto';

class MedicalCheckupDocumentsService {
    baseUrl: string = "/api/v1/medical-checkup-documents";

    getDocumentDownloadLink = (documentId: number) => {
        return api.get<AppResponse<LinkObjectDto>>(`${this.baseUrl}/${documentId}/download-link`);
    }
}

export const medicalCheckupDocumentsService = new MedicalCheckupDocumentsService();
